import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { PecasAtendidasCadastroComponent } from './pecas-atendidas-cadastro/pecas-atendidas-cadastro.component';
import { PecasAtendidasFiltroComponent } from './pecas-atendidas-filtro/pecas-atendidas-filtro.component';
import { PecasAtendidasListaComponent } from './pecas-atendidas-lista/pecas-atendidas-lista.component';
import { PecasAtendidasService } from './pecas-atendidas-service/pecas-atendidas.service';
import { PecasAtendidasComponent } from './pecas-atendidas.component';
import { FileUploadModule } from './../../../shared/fileupload/fileupload';


@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS),
    FileUploadModule
  ],
  exports: [
    PecasAtendidasComponent
  ],
  declarations: [
    PecasAtendidasComponent,
    PecasAtendidasCadastroComponent,
    PecasAtendidasListaComponent,
    PecasAtendidasFiltroComponent
  ],
  providers: [
    PecasAtendidasService
  ]
})
export class PecasAtendidasModule { }
